import StretchList from "./StretchList";
export default StretchList;